// Axios
import { instance } from './axios.instance';

export const createCustomTextVariable = async ({ name, remarks }) => {
  const { data } = await instance.post('/custom_text_variable/create', {
    custom_text_variable: { name, remarks },
  });
  return data;
};

// `predefinedValues` n'est envoyé que lorsqu'il est fourni : une clé absente
// laisse la colonne intacte côté Rails (update partiel).
export const updateCustomTextVariable = async ({
  name,
  id,
  remarks,
  predefinedValues,
}) => {
  const { data } = await instance.post('/custom_text_variable/update', {
    id,
    custom_text_variable: {
      name,
      remarks,
      ...(predefinedValues ? { predefined_values: predefinedValues } : {}),
    },
  });
  return data;
};
